import { createApp } from 'vue'
import { IonicVue } from '@ionic/vue'
import VueToast from 'vue-toastification'

// 3rd parties
import sentry from '@/3rd-parties/sentry'

// directives
import registerDirectives from '@/directives'

// store
import store from '@/store'

// UI
import registerUIComponents from '@/components/UI'

// components
import App from '@/App.vue'

// router
import router from '@/router'

// Core CSS required for Ionic components to work properly
import '@ionic/vue/css/core.css'

// toast
import 'vue-toastification/dist/index.css'

// tooltip
import 'tippy.js/dist/tippy.css'

// tailwind
import '@/assets/tailwind/tailwind.css'

// global scss
import '@/assets/scss/index.scss'

sentry.init()

const app = createApp(App)
  .use(VueToast)
  .use(store)
  .use(IonicVue)
  .use(router)

registerDirectives(app)
registerUIComponents(app)

// eslint-disable-next-line promise/catch-or-return
router.isReady()
  // eslint-disable-next-line promise/always-return
  .then(() => {
    app.mount('#app')
  })
